import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { RESET } from "../types";

export const loadOrderCoordinatesThunk = createAsyncThunk(
  "operationData/loadOrderCoordinates",
  async ({}, { getState, dispatch }) => {
    try {
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

const ordersAdapter = createEntityAdapter({
  selectId: (order) => order?.order_id,
  sortComparer: (a, b) =>
    new Date(b?.preparation_start) - new Date(a?.preparation_start),
});

const initialState = {
  orders: ordersAdapter.getInitialState(),
  page: 1,
  loadingOrders: false,
  showOperationDataModal: false,
};

const operationDataSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    setLoadingOrders: (state, action) => {
      state.loadingOrders = action.payload;
    },
    setShowOperationDataModal: (state, action) => {
      state.showOperationDataModal = action.payload;
    },
    resetSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadOrderCoordinatesThunk.pending, (state) => {
        state.loadingOrders = true;
      })
      .addCase(loadOrderCoordinatesThunk.fulfilled, (state, action) => {
        ordersAdapter.setAll(state.orders, action.payload.orders);
        state.page = action.payload.page;
        state.showButtonMore = action.payload.showButtonMore;
        state.loadingOrders = false;
      })
      .addCase(RESET, () => initialState)
      .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state, action) => {
          state.error = action.error.message;
        }
      );
  },
});

export const {
  selectAll: selectAllOrderCoordinates,
  selectById: selectOrderById,
} = ordersAdapter.getSelectors((state) => state.orders.orders);

export const { setLoadingOrders, setShowOperationDataModal, resetSlice } =
  operationDataSlice.actions;
export default operationDataSlice.reducer;
